import {useRouteQuery} from '@vueuse/router';

export default function useSpeedMode() {
	const isSpeedMode = import.meta.server
		? computed(() => !!useRequestEvent()?.node?.req.url?.includes('speed=1'))
		: computed(() => useRouteQuery('speed').value === '1');

	return {isSpeedMode};
}
